import React from "react";

const DynamicField = ({ field, value, onChange, error }) => {
    const { name, type, properties = {}, FieldType } = field;
    const {
        label,
        hidden,
        disabled,
        required,
        placeholder,
        options = [],
    } = properties;
    if (hidden) return null;

    const getSafeUrl = (value) => {
        try {
            const url = new URL(String(value || "").trim());
            return ["http:", "https:"].includes(url.protocol) ? url.href : null;
        } catch (e) {
            return null;
        }
    };

    const getTermsLinks = () => {
        const list = Array.isArray(properties.termslinks) && properties.termslinks.length > 0
            ? properties.termslinks
            : [{ url: properties.termsurl, text: properties.termslinktext || "Terms & Conditions" }];

        return list
            .map((l) => ({ url: getSafeUrl(l?.url), text: String(l?.text || "").trim() }))
            .filter((l) => l.url && l.text);
    };

    const renderTermsText = () => {
        const text = label || "I accept the Terms & Conditions";
        const links = getTermsLinks();
        if (links.length === 0) return text;

        const lower = text.toLowerCase();
        const found = [];
        const missing = [];

        links.forEach((l) => {
            const at = lower.indexOf(l.text.toLowerCase());
            const end = at + l.text.length;
            const overlaps = found.some((f) => at < f.end && end > f.start);
            if (at === -1 || overlaps) missing.push(l);
            else found.push({ ...l, start: at, end });
        });
        found.sort((a, b) => a.start - b.start);

        const parts = [];
        let cursor = 0;
        found.forEach((f, i) => {
            parts.push(text.slice(cursor, f.start));
            parts.push(
                <a key={`l${i}`} href={f.url} target="_blank" rel="noopener noreferrer" className="terms-link">
                    {text.slice(f.start, f.end)}
                </a>
            );
            cursor = f.end;
        });
        parts.push(text.slice(cursor));

        missing.forEach((m, i) => {
            parts.push(" ");
            parts.push(
                <a key={`m${i}`} href={m.url} target="_blank" rel="noopener noreferrer" className="terms-link">
                    {m.text}
                </a>
            );
        });

        return <>{parts}</>;
    };

    const renderControl = () => {
        if (FieldType === "TermsConditions") {
            return (
                <label className="terms-field">
                    <input
                        type="checkbox"
                        name={name}
                        checked={!!value}
                        disabled={disabled}
                        aria-invalid={!!error}
                        onChange={(e) => onChange(name, e.target.checked, field)}
                    />
                    <span className="terms-text">
                        {renderTermsText()}
                        {required && <span className="mandatory-field"> *</span>}
                    </span>
                </label>
            );
        }

        if (type === "Heading") {

            return (<div className="formHeading">
                <div>
                    <h2 className="formHeading" style={{ lineHeight: 0, marginBottom: 0 }}>{properties.heading}</h2>
                </div>
                <div>
                    <h5>{properties.subheading}</h5>
                </div>
            </div>)
        }






        if (type === "dropdown") {
            return (
                <select
                    name={name}
                    value={value || ""}
                    disabled={disabled}
                    onChange={(e) => onChange(name, e.target.value, field)}
                >
                    <option value="" disabled>
                        {placeholder || "Select"}
                    </option>
                    {options.map((opt, i) => (
                        <option key={i} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
            );
        }

        if (type === "textarea") {
            return (
                <textarea
                    name={name}
                    value={value || ""}
                    disabled={disabled}
                    placeholder={placeholder}
                    onChange={(e) => onChange(name, e.target.value, field)}
                />
            );
        }

        if (type === "checkbox") {
            return (
                <input
                    type="checkbox"
                    name={name}
                    checked={!!value}
                    disabled={disabled}
                    onChange={(e) => onChange(name, e.target.checked, field)}
                />
            );
        }

        const inputType =
            type === "number" ? "tel" : type === "email" ? "email" : type || "text";

        return (
            <input
                type={inputType}
                name={name}
                value={value || ""}
                disabled={disabled}
                placeholder={placeholder}
                inputMode={type === "number" ? "numeric" : undefined}
                onChange={(e) => {
                    const v = type === "number"
                        ? e.target.value.replace(/\D/g, "")
                        : e.target.value;
                    onChange(name, v, field);
                }}
            />
        );
    };

    return (
        <>
            <div className="form-group">
                {
                    type !== "Heading" && FieldType !=="TermsConditions" && (
                        <label>
                            {label}
                            {required && <span className="mandatory-field"> * </span>} :
                        </label>
                    )
                }

                {renderControl()}
            </div>
            {error && <p className="textDanger">{error}</p>}
        </>
    );
};

export default DynamicField;
